import { createAction } from '@reduxjs/toolkit';

export const ADD_PRODUCT = 'products/getEmptyProducts';

export const addEmptyArray = createAction(
    ADD_PRODUCT,
    () => ({ payload: { products: [] } }),
);
